export const alignLeftCellStyle = {
  cellStyle: {
    textAlign: 'left',
  },
};

export const alignRightCellStyle = {
  cellStyle: {
    textAlign: 'right',
  },
};

export const alignCenterCellStyle = {
  cellStyle: {
    textAlign: 'center',
  },
};
